import React, { useMemo } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Home, Calendar, QrCode, Bell, User, ShieldCheck } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useApp } from "../contexts/AppContext";
import "./BottomNav.css";

const BottomNav = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { eventId } = useParams();
  const { unreadCount } = useApp();

  const navItems = useMemo(() => {
    const prefix = eventId ? `/event/${eventId}` : "";
    const items = [
      { path: prefix || "/", icon: Home, label: "Home" },
      { path: `${prefix}/my-schedule`, icon: Calendar, label: "Programme" },
      {
        path: `${prefix}/my-qr`,
        icon: QrCode,
        label: "My Pass",
        isCenter: true,
      },
      { path: `${prefix}/notifications`, icon: Bell, label: "Announcements" },
    ];

    if (user?.is_admin) {
      items.push({ path: "/admin", icon: ShieldCheck, label: "Admin" });
    } else {
      // Only show profile tab for non-admin users
      items.push({ path: `${prefix}/profile`, icon: User, label: "Profile" });
    }

    return items;
  }, [eventId, user]);

  const isActive = (path) => {
    if (path === (eventId ? `/event/${eventId}` : "/")) {
      return location.pathname === path || location.pathname === path + "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => (
        <button
          key={item.path}
          className={`nav-item ${isActive(item.path) ? "active" : ""} ${item.isCenter ? "center-item" : ""}`}
          onClick={() => navigate(item.path)}
          aria-label={item.label}
        >
          <div className={`nav-icon ${item.isCenter ? "center-icon" : ""}`}>
            <item.icon size={item.isCenter ? 28 : 22} />
            {item.path.includes("notifications") && unreadCount > 0 && (
              <span className="nav-badge">
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </div>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
